import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import type {
  FeatureTourReadinessSource,
  FeatureTourReadinessStatus,
} from '@customer-portal/data-access/feature-announcements';

export interface FeatureTourReadinessGateway {
  watch(
    source: FeatureTourReadinessSource,
  ): Observable<FeatureTourReadinessStatus>;
}

export const FEATURE_TOUR_READINESS_GATEWAY =
  new InjectionToken<FeatureTourReadinessGateway>(
    'FEATURE_TOUR_READINESS_GATEWAY',
  );
